import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CardsItem.styles';
import { MoreHorizontalIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';
import { Card } from '@/mock-data/cards';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { renderAdditionalInfo } from '@/components/Profile/Cards/CardsItem.helpers';

interface CardsItemProps {
  card: Card;
  openDrawer: (card: Card) => void;
}

export const CardsItem: React.FC<CardsItemProps> = ({ card, openDrawer }) => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <S.Main>
        <IconBox
          $filename={`${card.type}.png`}
          $width={45}
          $height={30}
          $iconWidth={34}
        />
        <div>
          <S.Name $variant="1">{card.name}</S.Name>
          <S.Details>
            <S.BankName $variant="1">{card.bank}</S.BankName>
            <S.AdditionalInfo $variant="1" $isGreen={card.isMain}>
              {renderAdditionalInfo(t, card)}
            </S.AdditionalInfo>
          </S.Details>
        </div>
      </S.Main>
      <Button
        size="m"
        hasPadding={false}
        appearance="transparent"
        onClick={() => openDrawer(card)}
      >
        <MoreHorizontalIcon />
      </Button>
    </S.Box>
  );
};
